{
  "table": {
    "ranAt": "Se ejecutó en",
    "type": "Tipo",
    "numPortfolios": "# Carteras",
    "organization": "Organización",
    "state": "Estado",
    "actions": "Acciones",
    "run": "Ejecutar",
    "bulkV2Unavailable": "La optimización masiva aún no está disponible para el Optimizador V2."
  },
  "filters": {
    "selectOrganization": "Seleccione una organización"
  },
  "portfolioOptimizerType": {
    "DRIFT": "Desviación",
    "TRANSFER": "Transferencia"
  },
  "portfolioOptimizerState": {
    "CANCELED": "Cancelado",
    "COMPLETED": "Completado",
    "INITIATED": "Iniciado",
    "SOLVING_FOR_PURCHASES": "Resolver las compras",
    "PURCHASES_SOLVED": "Compras resueltas",
    "OPTIMAL_PORTFOLIOS_GENERATED": "Carteras óptimas generadas",
    "OPTIMAL_PORTFOLIOS_GENERATING": "Generación de carteras óptimas",
    "SOLVING_FOR_REDEMPTIONS": "Resolución de reembolsos",
    "REDEMPTIONS_SOLVED": "Reembolsos resueltos",
    "REBALANCING": "Reequilibrio",
    "REBALANCED": "Reequilibrado",
    "TAX_OPTIMIZING": "Optimización fiscal",
    "TAX_OPTIMIZED": "Impuesto optimizado",
    "GENERATING_ALLOCATIONS": "Generación de asignaciones",
    "FAILED": "Fallido"
  },
  "selectOptimizerModal": {
    "title": "Seleccionar tipo y paso del optimizador",
    "subTitle": "Seleccione si desea optimizar las carteras en función de la desviación o del efectivo",
    "setType": "Seleccionar tipo de optimizador",
    "setStep": "Seleccione el paso en el que desea hacer una pausa",
    "TRANSFER": "Optimizador de efectivo",
    "DRIFT": "Optimizador de desviaciones",
    "COMPLETE_ALL_STEPS": "Completar todos los pasos",
    "OPTIMAL_PORTFOLIOS_GENERATED": "Paso 1: Carteras óptimas generadas",
    "REDEMPTIONS_SOLVED": "Paso 2: Reembolsos resueltos",
    "PURCHASES_SOLVED": "Paso 3: Compras resueltas",
    "REBALANCED": "Paso 4 - Reequilibrio",
    "TAX_OPTIMIZED": "Paso 5: Impuesto optimizado"
  },
  "detail": {
    "summaryResults": "Resumen general",
    "proceedToBulkTrader": "Proceder con la operación masiva",
    "portfolioOptimizerState": "El optimizador de carteras está en estado {{state}}",
    "portfolioOptimizerNewState": "El optimizador de carteras se encuentra en estado {{state}}",
    "cancel": "Cancelar"
  },
  "stats": {
    "buys": "Compras",
    "sells": "Ventas",
    "portfoliosAdjusted": "Ajuste de carteras",
    "shares": "Acciones",
    "amount": "Importe"
  },
  "transitions": {
    "cancel": "Cancelar"
  },
  "run": "Ejecutar"
}
